import { render, staticRenderFns } from "./notificationsDropdown.vue?vue&type=template&id=27323d83&scoped=true&"
import script from "./notificationsDropdown.vue?vue&type=script&lang=js&"
export * from "./notificationsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./notificationsDropdown.vue?vue&type=style&index=0&id=27323d83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27323d83",
  null
  
)

export default component.exports